<template>
  <v-app>
    <v-app-bar dense app hide-on-scroll scroll-threshold="0">
      <AppbarAccount></AppbarAccount>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
    import AppbarAccount from './components/AppbarAccount';
export default {
  name: 'App',
  components: {
     AppbarAccount,
  },
  data: () => ({
    //
  }),
};
</script>
